import React from 'react';
import { useParams } from 'react-router-dom';
import DrugSearchSection from '../PharmacySearch/DrugSearchSection';

const MarketplacePage = () => {
  const { category } = useParams();
  
  return (
    <div style={{ width: '100%' }}>
      <DrugSearchSection initialCategory={category || 'pharmacy'} />
    </div>
  );
};

export default MarketplacePage;
